export class RouteHistorySubTab {
  public moduleName: string;
  public tabName: string;
  public tabIndex: number;

  constructor(moduleName: string, tabName: string, tabIndex: number){
    this.moduleName = moduleName;
    this.tabName = tabName;
    this.tabIndex = tabIndex;
  }
}


// WEBPACK FOOTER //
// ./src/app/pillar/layout/route-history-sub-tab.ts